import { DeviceType } from "../models/ChannelType";
import { itx } from "../translationItx/itx";

/** Typed controls for the effective device base properties. */
export default function DeviceBasePropertyInput({ property, value, label, onChange }: {
  property: string; value: string | number | boolean; label: string;
  onChange: (value: string | number | boolean) => void;
}) {
  const options = property === "type" ? ["Simple", "Touch", "Panel"]
    : property === "deviceType" ? Object.values(DeviceType) : undefined;
  if (options) return <select aria-label={label} value={String(value)} onChange={event => onChange(event.target.value)}>
    {options.map(option => <option key={option} value={option}>{option}</option>)}
  </select>;
  if (typeof value === "boolean") return <select aria-label={label} value={String(value)} onChange={event => onChange(event.target.value === "true")}>
    <option value="true">{property === "horizontal" ? itx("baseProps.horizontalValue", "Horizontal") : itx("baseProps.yes", "Ja")}</option>
    <option value="false">{property === "horizontal" ? itx("baseProps.verticalValue", "Vertikal") : itx("baseProps.no", "Nein")}</option>
  </select>;
  if (property === "supportsLongPress" || property === "supportsSlap") return <select aria-label={label} value={String(value)} onChange={event => onChange(Number(event.target.value))}>
    <option value="0">{itx("baseProps.no", "Nein")}</option>
    <option value="1">{itx("baseProps.yes", "Ja")}</option>
    <option value="2">{property === "supportsSlap" ? itx("baseProps.longSlapSupported", "Langer Patsch unterstützt") : itx("baseProps.extraLongSupported", "Extralang unterstützt")}</option>
  </select>;
  if (typeof value === "number") {
    const dimension = property === "heightMm" || property === "widthMm";
    const min = dimension ? 0.1 : property === "statusLeds" ? 0 : 1;
    return <input type="number" aria-label={label} value={value} min={min} step={dimension ? "any" : 1} onChange={event => {
      const next = event.target.valueAsNumber;
      if (Number.isFinite(next) && next >= min && (dimension || Number.isInteger(next))) onChange(next);
    }} />;
  }
  return <input aria-label={label} value={String(value)} onChange={event => onChange(event.target.value)} />;
}
